import { Menu, MenuButton, MenuItem, MenuPopover } from "@reach/menu-button";
import Icon from "assets/icons";
import React from "react";
import { EditDeleteActionsProps } from "./types";
import { positionRight } from "@reach/popover";
import { useCopies } from "shared/hooks/useCopies";
import classNames from "classnames";
import Button from "shared/components/button";
import Variant from "shared/enums/Variant";

export default function EditDeleteActions(props: EditDeleteActionsProps) {
  const copies = useCopies();
  return (
    <React.Fragment>
      {props.floating ? (
        <div className={classNames("dropDnMenu menuActions", props.additionalClass)}>
          <Menu>
            <MenuButton onClick={props.menuClickHandler}>
              <Icon.MenuDots />
            </MenuButton>
            <MenuPopover position={positionRight} className="slide-down newMenuDropdownList menuActions_list">
              <div className="newMenuDropdownList--container">
                <div className="newMenuDropdownList--items">
                  <React.Fragment>
                    {props.editClickHandler && (
                      <MenuItem
                        disabled={props.disabled || props.editDisabled}
                        onSelect={props.editClickHandler}
                        className="menuActions_list_edit">
                        <Icon.EditIcon /> {copies.get("edit")}
                      </MenuItem>
                    )}
                    {props.viewClickHandler && (
                      <MenuItem
                        disabled={props.disabled || props.editDisabled}
                        onSelect={props.viewClickHandler}
                        className="menuActions_list_edit">
                        <Icon.VisibilityIcon /> {copies.get("view")}
                      </MenuItem>
                    )}
                    {props.deleteClickHandler && (
                      <MenuItem
                        disabled={props.disabled || props.deleteDisabled}
                        onSelect={props.deleteClickHandler}
                        className="menuActions_list_delete">
                        <Icon.Delete /> {copies.get("delete")}
                      </MenuItem>
                    )}
                    {props.additionalActionClickHandler && (
                      <MenuItem
                        disabled={props.disabled || props.additionalActionDisabled}
                        onSelect={props.additionalActionClickHandler}
                        className={props.additionalActionClassName}>
                        {props.additionalActionIcon}
                        {props.additionalAction}
                      </MenuItem>
                    )}
                    {props.customMenuItems}
                  </React.Fragment>
                </div>
              </div>
            </MenuPopover>
          </Menu>
        </div>
      ) : (
        <div
          className={classNames("flatActions", {
            floatingFlatButtons: props.floatingFlatButtons,
            floatingFlatButtonsWithText: props.floatingFlatButtonsWithText
          })}>
          {props.viewClickHandler && (
            <Button
              disabled={props.disabled || props.editDisabled}
              onClick={props.viewClickHandler}
              className="flatActions_edit"
              title={copies.get("view")}
              icon={<Icon.VisibilityIcon />}
              label={props.floatingFlatButtonsWithText ? copies.get("view") : undefined}
            />
          )}
          {props.editClickHandler && (
            <Button
              disabled={props.disabled || props.editDisabled}
              onClick={props.editClickHandler}
              className="flatActions_edit"
              icon={<Icon.EditIcon />}
              label={props.floatingFlatButtonsWithText ? copies.get("edit") : undefined}
              title={copies.get("edit")}
            />
          )}
          {props.deleteClickHandler && (
            <Button
              disabled={props.disabled || props.deleteDisabled}
              variant={Variant.ERROR}
              onClick={props.deleteClickHandler}
              className="flatActions_delete"
              icon={<Icon.Delete />}
              title={copies.get("delete")}
              label={props.floatingFlatButtonsWithText ? copies.get("delete") : undefined}
            />
          )}
          {props.submitClickHandler && (
            <Button
              disabled={props.disabled || props.saveDisabled}
              variant={Variant.SUCCESS}
              onClick={props.submitClickHandler}
              className="flatActions_check"
              title={copies.get("save")}
              icon={<Icon.MatCheck />}
              label={props.floatingFlatButtonsWithText ? copies.get("save") : undefined}
            />
          )}
          {props.closeClickHandler && (
            <Button
              disabled={props.disabled || props.closeDisabled}
              variant={Variant.ERROR}
              onClick={props.closeClickHandler}
              className="flatActions_close"
              icon={<Icon.MatClose />}
              title={copies.get("cancel")}
              label={props.floatingFlatButtonsWithText ? copies.get("cancel") : undefined}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
}
